/* eslint-disable @typescript-eslint/no-empty-function */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const asyncNoop = async (): Promise<never> => {}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const noop = (): never => {}
